import React, { FunctionComponent } from 'react';
import { FormControl, FormHelperText, Grid, NativeSelect } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type FieldLanguageProps = {
    error: boolean;
    onChange: React.ChangeEventHandler<HTMLSelectElement>;
    value: number;
    formHelperText: string;
};

function cmp(prev: FieldLanguageProps, cur: FieldLanguageProps): boolean {
    return prev.error === cur.error && prev.formHelperText === cur.formHelperText && prev.value === cur.value;
}

const LANGUAGES = ['RUS', 'ENG', 'TGK'];

const FieldLanguage: FunctionComponent<FieldLanguageProps> = React.memo(({ error, onChange, value, formHelperText }) => {
    const [t] = useTranslation();
    return <Grid item xs={12} sm={3}>
        <FormControl error={error} fullWidth size="small">
            <NativeSelect onChange={onChange} value={value}>
                {LANGUAGES.map(lang => <option key={lang} value={lang}>{t('ru.languages.' + lang)}</option>)}
            </NativeSelect>
            <FormHelperText> {formHelperText} </FormHelperText>
        </FormControl>
    </Grid>;
}, cmp);

export default FieldLanguage;